module.exports = __webpack_public_path__ + "static/media/IMG_1846.52c71751.JPG";